<template>
  <div v-if="initialized" class="private-module-content">
    <the-main-menu :links="nav">
      <template slot="brand">
        <img src="/static/logo.png" class="brand-logo" alt="logo">
      </template>
      <template slot="navbar">
        <b-dropdown
          no-caret
          lazy
          size="sm"
          variant="dark"
          class="user-panel"
          :text="account.panel.name"
          v-if="this.getAccount().testUser"
          @shown="handlePanelSwitchOpen"
        >
          <b-dropdown-item-button v-if="panels.length === 0" disabled>
            <loading size="xs" />
          </b-dropdown-item-button>
          <b-dropdown-item-button v-for="panel in panels" :key="panel.id" @click="switchPanel(panel.id)">
            {{ panel.name }}
          </b-dropdown-item-button>
        </b-dropdown>
        <notifications :count="$store.state.notifications.count"
                       @openNotification="openNotification($event)"
                       vuex="notification/load"
                       class="d-inline-block"
        />
        <b-dropdown class="btn-user-dropdown" v-if="account !== null">
          <template slot="button-content">
            <div class="avatar d-inline">
              <img src="/static/avatar.svg" class="default-avatar" v-if="account.imageUrl === null">
              <img :src="account.imageUrl" v-if="account.imageUrl !== null">
            </div>
            <span class="user-name">{{account.fullName}}</span>
          </template>
          <b-dropdown-item :to="{name: 'profile', params: {type: 'change-password'}}">
            {{t('Change password')}}
          </b-dropdown-item>
          <b-dropdown-item :to="{name: 'profile', params: {type: 'update'}}">
            {{t('Update profile')}}
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="logout()">{{t('Logout')}}</b-dropdown-item>
        </b-dropdown>
      </template>
    </the-main-menu>
    <main role="main" class="container">
      <router-view></router-view>
    </main>
    <div class="container">
      <footer id="main-footer">
        <div v-html="t('_FooterTextInfo')"></div>
        Copyright (c) CEEOR 2019. <a href="http://www.ceeor.com" target="_blank">www.ceeor.com</a>
      </footer>
    </div>
    <post-login-popup
      :title="t('Condition terms title')"
      :text="t('_Registration conditions terms')"
      :conditions="termsConditions"
    />
  </div>
</template>

<script>
    import TheMainMenu from '../../admin/Layout/TheMainMenu';
    import Notifications from '../../components/notifications';
    import PostLoginPopup from './PostLoginPopup';
    import {encryptBackdata} from './patients/helper';
    import TitanForm from '../../core/Form/Form'
    import Loading from '../../core/Components/loading'

    export default {
        components: {
            PostLoginPopup,
            TheMainMenu,
            Notifications,
            TitanForm,
            Loading
        },
        created() {
            this.$store.dispatch('notifications/count')
            encryptBackdata(this.$store.getters['account/userStore'].getLoggedUser(),this.$store).then(() => {
                this.initialized = true;
            });

        },
        mounted() {
            document.body.classList.remove('public');
        },
        computed: {
            account() {
                return this.$store.state.account.user;
            }
        },
        methods: {
            openNotification(data) {
                this.$store.dispatch('notifications/update', {id: data.id, seenOn: 'now'}).then(() => {
                    this.$store.dispatch('notifications/count')
                });
                if (data.slug === 'applicationExpiration' || data.slug === 'insuranceExpiration' || data.slug === 'newEmailFromInsurance') {
                    this.$router.push({name: 'manageApplication', params: {id: data.json.applicationId}});
                }
            },
            handlePanelSwitchOpen() {
              this.loadPanels()
            },
            loadPanels() {
              if (this.panels.length === 0) {
                this.$store.dispatch('codeBook/load', 'panel').then(response => {
                  this.panels = this.$store.getters['codeBook/get']('panel');
                }).catch(error => {
                  // todo catch error ?
                });
              }
            },
            switchPanel(id) {
              this.loading = true
              this.$store.dispatch('account/changePanel', { id })
                .then(response => {
                  this.loading = false
                  if (response.data.error) {
                    this.$store.dispatch('alert/danger', this.t(response.data.status));
                    return;
                  }

                  this.$store.dispatch('alert/success', this.t('Panel changed, the page will refresh soon ..'))
                  setTimeout(() => window.location.reload(), 3000);
                })
            },
            logout() {
                this.$store.dispatch('account/logout').then(response => {
                    this.$router.push({name: 'login'});
                }).catch(error => {
                    this.$router.push({name: 'login'})
                });
            },
        },
        data() {
            return {
                initialized: false,
                nav: [
                    {
                        name: this.t('Dashboard'),
                        route: {name: 'dashboard'},
                        new: false,
                    }, {
                        name: this.t('Patients'),
                        route: {name: 'patients', params: {page: 1}},
                        new: false,
                        visible: () => {
                            return this.hasPermission('PatientsTitan', 'R');
                        }
                    }, {
                        name: this.t('Applications'),
                        route: {name: 'applications', params: {page: 1}},
                        new: false,
                        visible: () => {
                            return this.hasPermission('ApplicationsTitan', 'R');
                        }
                    }, {
                        name: this.t('Admin'),
                        route: {name: 'adminTranslator', params: {page: 1}},
                        new: false,
                        visible: () => {
                            return this.hasPermission('TranslateTitan', 'R')
                                || this.hasPermission('TemplateTitan', 'R');
                        }
                    }, {
                        name: this.t('Users'),
                        route: {name: 'users', params: {page: 1}},
                        new: false,
                        visible: () => {
                            return this.hasPermission('UserTitan', 'R');
                        }
                    }, {
                        name: this.t('Sub-users'),
                        route: {name: 'subUsersList', params: {page: 1}},
                        new: false,
                        visible: () => {
                            return this.hasPermission('NurseTitan', 'R');
                        }
                    }, {
                        name: this.t('Video instructions'),
                        link: '/mendel_instruktazne_video.mp4',
                        target: '_blank',
                        new: false
                    }, {
                        name: this.t('Documents'),
                        route: {name: 'documents'},
                        new: false,
                        visible: () => {
                            return true;
                        }
                    }, {
                        name: this.t('Report'),
                        route: {name: 'report'},
                        new: false,
                        visible: () => {
                            return this.hasPermission('ReportTitan', 'R');
                        }
                    }
                ],
                termsConditions: [
                    {
                        label: this.t('Conditions terms label'),
                        title: this.t('Condition terms title'),
                        clickText: this.t('Conditions click text'),
                        model: 'consentTerms',
                        text: this.t('_Registration conditions terms'),
                        required: true,
                        default: false
                    },
                    {
                        label: this.t('Marketing purposes consent'),
                        model: 'consentMarketing',
                        required: false,
                        default: false
                    },
                    {
                        label: this.t('Survey invitations consent'),
                        model: 'consentInvitations',
                        required: false,
                        default: false
                    }
                ],
                loading: false,
                panels: [],
            }
        }
    }
</script>
<style lang="scss">
  .user-panel {
    .dropdown-toggle-no-caret {
      color: #6c757d;

      &:after {
        display:none;
      }
    }
  }
  #main-footer {
    margin-top: 20px;
    font-size: 12px;
    color: gray;
  }

  body {
    padding-bottom: 30px;
  }

  #modal-terms-conditions {
    .modal-body {
      height: 25rem;
      overflow-y: scroll;
    }
  }

  .modal-body #main-footer {
    margin-top: 50px;
    border-top: 2px solid #e3e6ea;
    padding-top: 10px;
    font-size: 15px;
    color: #a9b2bb;

    a {
      color: #a9b2bb;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/Private.vue